import React, { Component } from 'react';
import { ListView, PullToRefresh } from 'antd-mobile';
import { Link } from 'react-router-dom';
import sysConfig from '../../../sysConfig.js';
import { execute } from '../../../services/saas/onlineCourseTour';
import { getUser } from '../../../utils';

class ClassList extends Component {
  constructor(props) {
    super(props);
    // 创建ListViewDataSource对象
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2, // rowHasChanged(prevRowData, nextRowData); 用其进行数据变更的比较
    });
    this.classList = [];
    this.state = {
      dataSource,
      pageSize: 20,
      pageIndex: 1,
      hasMore: true,
      loading: false,
      refreshing: false,
      classname: this.props.classname,
    };
    this.getList = this.getList.bind(this);
    this.getClassList = this.getClassList.bind(this);
    this.concatList = this.concatList.bind(this);
    this.onEndReached = this.onEndReached.bind(this);
  }
  async componentDidMount() {
    await this.getClassList(this.state.classname);
  }
  async componentWillReceiveProps(nextProps, nextContext) {
    await this.getClassList(nextProps.classname);
    await this.setState({
      classname: nextProps.classname,
    });
  }
  componentWillUnmount() {
    this.setState = () => false;
  }

  async onEndReached() {
    if (!this.state.hasMore) {
      return;
    }
    this.setState({
      loading: true,
      pageIndex: this.state.pageIndex + 1,
    });
    await this.concatList(this.state.classname);
  }
  async getClassList(classname, pageIndex = 1) {
    await this.getList(classname, pageIndex).then((result) => {
      this.classList = result.data;
      this.setState({
        pageIndex: result.current,
        hasMore: result.current < result.pages,
      });
    });
    this.setState({
      dataSource: this.state.dataSource.cloneWithRows(this.classList),
      loading: false,
      refreshing: false,
    });
  }
  async concatList(classname) {
    if (!this.state.hasMore) {
      return;
    }
    let datalist = [];
    await this.getList(classname, this.state.pageIndex + 1).then((result) => {
      datalist = result.data;
      this.setState({
        pageIndex: result.current,
        hasMore: result.current < result.pages,
      });
    });
    this.classList = this.classList.concat(datalist);
    this.setState({
      dataSource: this.state.dataSource.cloneWithRows(this.classList),
      loading: false,
      refreshing: false,
    });
  }
  async getList(classname, pageIndex) {
    const { userId } = getUser() || {};
    let param = {
      method: 'listEquipments',
      params: {
        equipmentTypes: '0301,0302,0303,0308,0309,0318,0319',
        userId: userId,
        name: classname,
        size: this.state.pageSize,
        current: pageIndex,
      },
    };
    let res = await execute(param);
    if (res.success && res.code === 200) {
      return {
        data: res.data.records,
        current: res.data.current,
        pages: res.data.pages,
        total: res.data.total,
        msg: res.msg,
        success: res.success,
      };
    } else {
      return {
        data: [],
        current: 1,
        pages: 1,
        total: 0,
        msg: res.msg,
        success: res.success,
      };
    }
  }
  render() {
    const { preRouteUrl } = sysConfig;
    const row = (rowData, _, rowID) => {
      const { id, roomName, name, linkStatus, roomId } = rowData;
      return (
        <li
          className={linkStatus === '0' ? 'disabled' : ''}
          key={'onlineCourseTour-list-item_' + rowID}
        >
          <Link
            to={{
              pathname: `${preRouteUrl}/supervise/tourVideo/${id}/${roomId}`,
              // query:{id:id},
              // state: { id: id, deptId: deptId, deptDataAuth: deptDataAuth, roomId: roomId },
            }}
          >
            <div className="item-content">
              <div className="item-content-left">
                <img src={[require('../../../images/ico_faculty.png')]} alt="院系" />
              </div>
              <div className="item-content-right">
                <p>
                  <label>{[roomName, name].filter((item) => item).join('/')}</label>
                </p>
              </div>
            </div>
          </Link>
        </li>
      );
    };
    return (
      <ListView
        dataSource={this.state.dataSource}
        renderHeader={() => null}
        renderFooter={() => (
          <div style={{ padding: '5vw', textAlign: 'center', fontSize: '3vw' }}>
            {this.state.hasMore ? (this.state.loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="onlineCourseTour-content"
        pageSize={this.state.pageSize}
        initialListSize={this.state.pageSize}
        scrollRenderAheadDistance={100}
        onEndReached={this.onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            direction="down"
            distanceToRefresh="25"
            indicator="activate: ReactNode, deactivate: ReactNode, release: ReactNode, finish: ReactNode"
            refreshing={this.state.refreshing}
            onRefresh={async () => {
              this.setState({
                refreshing: true,
              });
              await this.getClassList(this.state.classname);
            }}
          />
        }
      />
    );
  }
}
class ListWrap extends Component {
  render() {
    return <ul className="onlineCourseTour-ul">{this.props.children}</ul>;
  }
}

export { ClassList };
